// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a3277648","239":"6451a7bd","453":"8c36159b","455":"773a6fed"}[chunkId] + ".chunk.js";
};